import { CircularProgress } from "@mui/material";
import React from "react";
import { ReactComponent as UpDownIcon } from "../../../../../assets/images/up-down-icon.svg";
import { ReactComponent as UpDownIcon2 } from "../../../../../assets/images/up-down-icon_v1.svg";
import { ReactComponent as BitCoin } from "../../../../../assets/images/bitcoin-icon.svg";
import { formatCoin, formatNumberForOdds, renderPercent } from "../../../../../utils/utils";
import useDeviceDetect from "../../../../../hook/useDeviceDetect";
import { formatNumber } from "../../../../../services/utility/utils";

export default function Result(props: any) {
  const { closePrice, isAbove, odds, operatorId, lang } = props;
  const { isTablet } = useDeviceDetect();
  return (
    <div
      className={`wrap-item wrap-item-result
    ${closePrice ? `wrap-item-result-${isAbove ? "up" : "down"}` : ""}

    animate__animated
    
    ${isTablet ? "animate__zoomIn animate-delay-03" : "animate__fadeInRight animate-delay-04"}
    `}
    >
      <div className="content-result">
        <div className={`wrap-icon wrap-icon-${isAbove ? "up" : "down"}`}>
          {operatorId === 2 ? <UpDownIcon2 /> : <UpDownIcon />}
        </div>

        <div className="icon-bit-coin">
          <BitCoin />
        </div>
        <p className="label-lock-price">{lang?.final_price|| "Final Price"}</p>
        <div
          className={`wrap-lock-price wrap-lock-price-${
            isAbove ? "up" : "down"
          }`}
        >
          <span className="syb">$</span>
          <span className="value">{formatCoin(closePrice, 0)}.</span>
          <span className="percent">{renderPercent(closePrice)}</span>
        </div>
        <p className={`price-odds price-odds-${isAbove ? "up" : "down"}`}>
          {isAbove ? lang?.up_by || "Up by" : lang?.down_by || "Down by"}
          <span className="odds"> ${formatNumberForOdds(odds)}</span>
        </p>
      </div>
      <div
        className={`wrap-loading-result animate__animated 
        ${closePrice && "puff-out-center"}
      `}
      >
        <p className="loading">
          {lang?.loading_fn || "Loading"}
          <br />
          {lang?.final_price|| "Final Price"}
        </p>
        <CircularProgress
          size={20}
          className="circular-progress"
          style={{
            color: "#B3BECE",
          }}
        />
      </div>
    </div>
  );
}
